import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly cookie set by the backend – nothing is kept in localStorage.
const api = axios.create({ baseURL: API, withCredentials: true });

export function apiErr(e, fallback = "Něco se nezdařilo. Zkuste to prosím znovu.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d === "object") return d.message || JSON.stringify(d);
  return String(d);
}

export default api;
